/*
 * Verlauf einer Linie oder Leitung im HMI (28.10.2026): Punkte in Pixeln,
 * Ecken auf Wunsch gerundet. Eigenes Modul, damit es ohne Darstellung testbar ist.
 */
type Pt = [number, number];

export function validRoute(route: unknown): Pt[] | null {
  if (!Array.isArray(route) || route.length < 2) return null;
  const pts = route.filter((p): p is Pt =>
    Array.isArray(p) && p.length === 2 && Number.isFinite(p[0]) && Number.isFinite(p[1]));
  return pts.length >= 2 ? pts : null;
}

/** Streckenzug mit Viertelbogen-artigen Ecken: an jedem inneren Punkt wird
 *  um hoechstens den halben Abstand zu den Nachbarn abgerundet. */
export function roundedRoute(pts: Pt[], radius: number): string {
  const f = (n: number) => Math.round(n * 10) / 10;
  let d = `M${f(pts[0][0])} ${f(pts[0][1])}`;
  for (let i = 1; i < pts.length - 1; i++) {
    const [px, py] = pts[i - 1], [cx, cy] = pts[i], [nx, ny] = pts[i + 1];
    const l1 = Math.hypot(cx - px, cy - py), l2 = Math.hypot(nx - cx, ny - cy);
    const r = Math.min(radius, l1 / 2, l2 / 2);
    if (r <= 0 || l1 === 0 || l2 === 0) { d += ` L${f(cx)} ${f(cy)}`; continue; }
    const ax = cx - ((cx - px) / l1) * r, ay = cy - ((cy - py) / l1) * r;
    const bx = cx + ((nx - cx) / l2) * r, by = cy + ((ny - cy) / l2) * r;
    d += ` L${f(ax)} ${f(ay)} Q${f(cx)} ${f(cy)} ${f(bx)} ${f(by)}`;
  }
  const last = pts[pts.length - 1];
  return `${d} L${f(last[0])} ${f(last[1])}`;
}

